import {
  MESSAGENOTIFICATION,
} from '../actions/messageNotification';

import {reducerPackage} from "../../utils";

export const messageNotificationList =reducerPackage(MESSAGENOTIFICATION);
